// Sync with the backend
export enum SocketEvents {
  LOGIN,
  LOGOUT,
  INVITATIONS_UPDATE,
  NOTIFICATIONS_UPDATE,
  TEAM_MEMBER_REMOVED,
  TASK_COMMENTS_UPDATED,
  QUICK_TASK,
  QUICK_ASSIGNEES_UPDATE,
  TASK_STATUS_CHANGE,
  TASK_PRIORITY_CHANGE,
  TASK_NAME_CHANGE,
  TASK_LABELS_CHANGE,
  CREATE_LABEL,
  TASK_END_DATE_CHANGE,
  TASK_START_DATE_CHANGE,
  TASK_TIME_ESTIMATION_CHANGE,
  TASK_DESCRIPTION_CHANGE,
  GET_TASK_PROGRESS,
  TASK_TIMER_START,
  TASK_TIMER_STOP,
  TASK_SORT_ORDER_CHANGE,
  JOIN_OR_LEAVE_PROJECT_ROOM,
  PROJECT_UPDATES_AVAILABLE,
  TASK_SUBSCRIBERS_CHANGE,
  PROJECT_SUBSCRIBERS_CHANGE,
  TASK_PHASE_CHANGE,
  ROADMAP_SORT_ORDER_CHANGE,
  PHASE_START_DATE_CHANGE,
  PHASE_END_DATE_CHANGE,
  NEW_PROJECT_COMMENT_RECEIVED,
  PROJECT_HEALTH_CHANGE,
  PROJECT_START_DATE_CHANGE,
  PROJECT_END_DATE_CHANGE,
  PROJECT_STATUS_CHANGE,
  PROJECT_CATEGORY_CHANGE,
  CREATE_PROJECT_CATEGORY,
  PT_QUICK_TASK,
  PT_NAME_CHANGE,
  PT_TASK_SORT_ORDER_CHANGE,
  PT_TASK_NAME_CHANGE,
  PT_TASK_TIME_ESTIMATION_CHANGE,
  PT_TASK_DESCRIPTION_CHANGE,
  PT_TASK_LABELS_CHANGE,
  PT_CREATE_LABEL,
  PT_TASK_PHASE_CHANGE,
  PT_TASK_STATUS_CHANGE,
  PT_TASK_PRIORITY_CHANGE,
  GANNT_DRAG_CHANGE,
  SCHEDULE_MEMBER_ALLOCATION_CREATE,
  SCHEDULE_MEMBER_START_DATE_CHANGE,
  SCHEDULE_MEMBER_END_DATE_CHANGE,
  PROJECT_DATA_CHANGE,
  TASK_BILLABLE_CHANGE,
  TASK_RECURRING_CHANGE,
  TASK_ASSIGNEES_CHANGE,
  TASK_CUSTOM_COLUMN_UPDATE,
  CUSTOM_COLUMN_PINNED_CHANGE,
  TEAM_MEMBER_ROLE_CHANGE,
}
